<div class="container mx-auto device-content">
    <div class="hero-text" fxLayout="row" fxFlexAlign="center">
        <h1 style="font-weight:800;">{{'GARBAGE_CENTER_LOCATING_FORM'|translate}}</h1>
    </div>
    <form #form="ngForm" class="form container-fluid pl-0 pr-0">
        <div fxLayout="row wrap" fxFlexAlign="center">
            <div fxFlex="100" fxLayout="column" fxLayoutAlign="space-evenly start">
                <mat-form-field fxFlex="100" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'GARBAGE_CENTER_NAME'|translate}}</mat-label>
                    <input matInput placeholder="{{'GARBAGE_CENTER_NAME'|translate}}" name="garbage-name"
                        [(ngModel)]="this.container.streetDesc" required>
                </mat-form-field>
                <mat-form-field *ngIf="companyId==1" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'COMPANY'|translate}}</mat-label>
                    <mat-select [(ngModel)]="selectedCompany" (selectionChange)="onCompanyChange(selectedCompany)"
                        placeholder="{{'COMPANY'|translate}}" required name="companies">
                        <mat-option *ngFor="let item of companyList" name="copaniesOptions" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field style="width: 100%;" fxFlex="100" appearance="outline">
                    <mat-label>{{'PLEASE_SELECT_POLYGON'|translate}}</mat-label>
                    <mat-select [(ngModel)]="selectedPolygons" placeholder="{{'PLEASE_SELECT_POLYGON'|translate}}"
                        name="polygon" multiple>
                        <mat-option *ngFor="let polygon of polygonList" [value]="polygon">
                            {{polygon.name || '' }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <button style="margin-top: 10px;" mat-raised-button (click)="save()">
                <span>{{'CREATE'|translate}}</span>
            </button>
        </div>
    </form>
</div>